import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { FiMail, FiLock, FiEye, FiEyeOff } from 'react-icons/fi';
import toast from 'react-hot-toast';

export default function Login() {
    const { login } = useAuth();
    const navigate = useNavigate();

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});

    const validate = () => {
        const e = {};
        if (!email.trim()) e.email = 'Email is required';
        if (!password.trim()) e.password = 'Password is required';
        setErrors(e);
        return Object.keys(e).length === 0;
    };

    const handleSubmit = async (ev) => {
        ev.preventDefault();
        if (!validate()) return;
        setLoading(true);
        try {
            const user = await login(email, password);
            navigate(user.role === 'admin' ? '/admin' : '/dashboard');
        } catch (err) {
            const msg = err.response?.data?.message || 'Login failed. Please try again.';
            toast.error(msg);
            setErrors({ general: msg });
        } finally {
            setLoading(false);
        }
    };

    const iconStyle = {
        position: 'absolute', left: 14, top: '50%',
        transform: 'translateY(-50%)', color: '#64748b', fontSize: 16,
        pointerEvents: 'none'
    };

    return (
        <div
            className="cosmic-bg"
            style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '100px 20px 40px' }}
        >
            <div style={{ width: '100%', maxWidth: 440 }}>

                {/* Header */}
                <div style={{ textAlign: 'center', marginBottom: 36 }}>

                    <h1 className="text-gradient-purple" style={{ fontSize: 30, fontWeight: 800, fontFamily: 'Plus Jakarta Sans, sans-serif', marginBottom: 8 }}>
                        Welcome Back
                    </h1>
                    <p style={{ color: '#64748b', fontSize: 15 }}>Sign in to access your numerology readings</p>
                </div>

                <div className="glass-card" style={{ padding: 36 }}>

                    {/* General error */}
                    {errors.general && (
                        <div style={{
                            background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.3)',
                            borderRadius: 10, padding: '12px 16px', marginBottom: 20, color: '#f87171', fontSize: 14
                        }}>
                            ⚠️ {errors.general}
                        </div>
                    )}

                    <form onSubmit={handleSubmit} noValidate>

                        {/* Email */}
                        <div className="form-group">
                            <label className="form-label">Email Address</label>
                            <div style={{ position: 'relative' }}>
                                <FiMail style={iconStyle} />
                                <input
                                    type="email"
                                    className="form-control"
                                    placeholder="you@example.com"
                                    style={{ paddingLeft: 42 }}
                                    value={email}
                                    onChange={e => setEmail(e.target.value)}
                                    autoComplete="email"
                                />
                            </div>
                            {errors.email && <p className="form-error">{errors.email}</p>}
                        </div>

                        {/* Password */}
                        <div className="form-group">
                            <label className="form-label">Password</label>
                            <div style={{ position: 'relative' }}>
                                <FiLock style={iconStyle} />
                                <input
                                    type={show ? 'text' : 'password'}
                                    className="form-control"
                                    placeholder="••••••••"
                                    style={{ paddingLeft: 42, paddingRight: 44 }}
                                    value={password}
                                    onChange={e => setPassword(e.target.value)}
                                    autoComplete="current-password"
                                />
                                <button
                                    type="button"
                                    onClick={() => setShow(s => !s)}
                                    style={{
                                        position: 'absolute', right: 14, top: '50%', transform: 'translateY(-50%)',
                                        background: 'none', border: 'none', color: '#64748b', cursor: 'pointer', fontSize: 16, padding: 0
                                    }}
                                    tabIndex={-1}
                                >
                                    {show ? <FiEyeOff /> : <FiEye />}
                                </button>
                            </div>
                            {errors.password && <p className="form-error">{errors.password}</p>}
                        </div>

                        <button
                            type="submit"
                            className="btn btn-primary"
                            style={{ width: '100%', justifyContent: 'center', marginTop: 8 }}
                            disabled={loading}
                        >
                            {loading ? 'Signing In...' : 'Sign In'}
                        </button>

                    </form>

                    <div className="divider" style={{ margin: '24px 0' }} />
                    <p style={{ textAlign: 'center', color: '#64748b', fontSize: 14 }}>
                        Don't have an account?{' '}
                        <Link to="/register" style={{ color: '#7b96fa', fontWeight: 600, textDecoration: 'none' }}>
                            Create one free →
                        </Link>
                    </p>
                </div>
            </div>
        </div>
    );
}
